import React from 'react';
import { BrowserRouter, Routes, Route, useLocation, Navigate } from 'react-router-dom';
import { Toaster } from '@/components/ui/sonner';
import '@/App.css';
import LandingPage from '@/pages/LandingPage';
import Dashboard from '@/pages/Dashboard';
import FunnelSpy from '@/pages/FunnelSpy';
import AIComposer from '@/pages/AIComposer';
import LibraryPage from '@/pages/LibraryPage';
import Monitoring from '@/pages/Monitoring';
import MonitorDetail from '@/pages/MonitorDetail';
import Pricing from '@/pages/Pricing';
import PaymentSuccess from '@/pages/PaymentSuccess';
import Settings from '@/pages/Settings';
import BrandsSettings from '@/pages/BrandsSettings';
import Affiliates from '@/pages/Affiliates';
import Onboarding from '@/pages/Onboarding';
import Guia from '@/pages/Guia';
import HallOfWinners from '@/pages/HallOfWinners';
import NicheWinners from '@/pages/NicheWinners';
import Discovery from '@/pages/Discovery';
import WinnerScore from '@/pages/WinnerScore';
import AutoBuild from '@/pages/AutoBuild';
import ProductGenerator from '@/pages/ProductGenerator';
import Branding from '@/pages/Branding';
import Opportunities from '@/pages/Opportunities';
import Competitors from '@/pages/Competitors';
import Credits from '@/pages/Credits';
import CRM from '@/pages/CRM';
import Heatmap from '@/pages/Heatmap';
import BattlePreview from '@/pages/BattlePreview';
import Exports from '@/pages/Exports';
import RedeemGift from '@/pages/RedeemGift';
import FounderUsage from '@/pages/FounderUsage';
import FounderAnalytics from '@/pages/FounderAnalytics';
import AuthCallback from '@/components/AuthCallback';
import ProtectedRoute from '@/components/ProtectedRoute';
import ConsentBanner from '@/components/ConsentBanner';
import PrivacyPolicy from '@/pages/PrivacyPolicy';
import CookiePolicy from '@/pages/CookiePolicy';
import { ErrorBoundary } from '@/components/ErrorBoundary';
import { captureAttribution } from '@/lib/attribution';

function AppRouter() {
  const location = useLocation();

  React.useEffect(() => {
    captureAttribution();
  }, []);

  if (location.hash?.includes('session_id=')) {
    return <AuthCallback />;
  }
  
  return (
    <>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/guia" element={<Guia />} />
        <Route path="/privacy" element={<PrivacyPolicy />} />
        <Route path="/cookies" element={<CookiePolicy />} />
      <Route path="/hall-of-winners" element={<HallOfWinners />} />
      <Route path="/winners/:slug" element={<NicheWinners />} />
      <Route path="/b/:token" element={<BattlePreview />} />
      <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
      <Route path="/funnel-spy" element={<ProtectedRoute><FunnelSpy /></ProtectedRoute>} />
      <Route path="/discovery" element={<ProtectedRoute><Discovery /></ProtectedRoute>} />
      <Route path="/winner-score" element={<ProtectedRoute><WinnerScore /></ProtectedRoute>} />
      <Route path="/auto-build" element={<ProtectedRoute><AutoBuild /></ProtectedRoute>} />
      <Route path="/product-generator" element={<ProtectedRoute><ProductGenerator /></ProtectedRoute>} />
      <Route path="/branding" element={<ProtectedRoute><Branding /></ProtectedRoute>} />
      <Route path="/opportunities" element={<ProtectedRoute><Opportunities /></ProtectedRoute>} />
      <Route path="/competitors" element={<ProtectedRoute><Competitors /></ProtectedRoute>} />
      <Route path="/credits" element={<ProtectedRoute><Credits /></ProtectedRoute>} />
      <Route path="/credits/redeem" element={<ProtectedRoute><RedeemGift /></ProtectedRoute>} />
      <Route path="/crm" element={<ProtectedRoute><CRM /></ProtectedRoute>} />
      <Route path="/heatmap" element={<ProtectedRoute><Heatmap /></ProtectedRoute>} />
      <Route path="/exports" element={<ProtectedRoute><Exports /></ProtectedRoute>} />
      <Route path="/founder/usage" element={<ProtectedRoute><FounderUsage /></ProtectedRoute>} />
      <Route path="/founder/analytics" element={<ProtectedRoute><FounderAnalytics /></ProtectedRoute>} />
      <Route path="/ai-composer" element={<ProtectedRoute><AIComposer /></ProtectedRoute>} />
      <Route path="/library" element={<ProtectedRoute><LibraryPage /></ProtectedRoute>} />
      <Route path="/monitoring" element={<ProtectedRoute><Monitoring /></ProtectedRoute>} />
      <Route path="/monitoring/:id" element={<ProtectedRoute><MonitorDetail /></ProtectedRoute>} />
      <Route path="/pricing" element={<ProtectedRoute><Pricing /></ProtectedRoute>} />
      <Route path="/payment-success" element={<ProtectedRoute><PaymentSuccess /></ProtectedRoute>} />
      <Route path="/settings" element={<ProtectedRoute><Settings /></ProtectedRoute>} />
      <Route path="/settings/brands" element={<ProtectedRoute><BrandsSettings /></ProtectedRoute>} />
      <Route path="/affiliates" element={<ProtectedRoute><Affiliates /></ProtectedRoute>} />
      <Route path="/onboarding" element={<ProtectedRoute><Onboarding /></ProtectedRoute>} />
      </Routes>
      <ConsentBanner />
    </>
  );
}

function App() {
  return (
    <div className="App">
      <ErrorBoundary>
        <BrowserRouter>
          <AppRouter />
        </BrowserRouter>
      </ErrorBoundary>
      <Toaster position="bottom-right" theme="dark" />
    </div>
  );
}

export default App;